// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"923900ee","903":"3674380f"}[chunkId] + ".chunk.js";
};